import { NavItem } from "@/interfaces/nav";

const navItems: NavItem[] = [
  {
    name: "Articles",
    url: "/articles",
    type: "external",
  },
  {
    name: "Get in touch",
    url: "#get-in-touch",
    type: "internal",
  },
  {
    name: "About me",
    url: "#about-me",
    type: "internal",
  },
  {
    name: "Experience",
    url: "#experience",
    type: "internal",
  },
  {
    name: "Selected Work",
    url: "#selected-work",
    type: "internal",
  },
];

export default navItems;
